import type { Requests } from "../common/request.common";
import type { RadiusSessionResponseTypes } from "../common/response.common";
import { post } from "./common";

export const radiusSession = {
    record(accountId: string) {
        return (data: typeof Requests.RadiusSession.Record.Input) => {
            return post<typeof data, RadiusSessionResponseTypes.Record>(
                `/radius-session/record/${accountId}`,
                data,
            );
        };
    },
};
